/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import moment from 'moment'

import ChartColumnStacked from '../../../../components/charts/ChartColumnStacked'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartLineThemes } from '../../../../components/charts/types/ChartLine'
import { formatCurrency } from '../../../../utils/Helpers'
import { GET_MULTIPLE_SHOPPING_CART_HISTORY } from '../../../../queries/multipleShoppingCarts'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'
import { MultipleShoppingCartStatus, MultipleShoppingCartHistory } from '../../../../types/MultipleShoppingCart'

enum SeriesNames {
  delivered = 'Pedidos entregues',
  cancelled = 'Pedidos cancelados',
}

type Series = {
  name: string
  data: number[]
}

const MultipleShoppingCancelledDeliveredHistory = (): JSX.Element => {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const categories: Array<string> = []

  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_MULTIPLE_SHOPPING_CART_HISTORY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: {
        filters: {
          createdAt: {
            initialDate: `${filters.date.year}-${filters.date.month}||/M`,
            finalDate: `${filters.date.year}-${filters.date.month}||/M`,
            format: 'yyyy-M',
            time_zone: filters.date.time_zone
          }
        }
      }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data || error) return <ChartColumnSkeleton />
  if (!data.ordersAggs.aggregations.statuses.buckets) return <p>No data found</p>

  const bucketsStatus: MultipleShoppingCartStatus[] = data.ordersAggs.aggregations.statuses.buckets

  const seriesDelivered: Series = {
    name: SeriesNames.delivered,
    data: []
  }

  const seriesCancelled: Series = {
    name: SeriesNames.cancelled,
    data: []
  }

  const bucketsDelivered: MultipleShoppingCartHistory[] = bucketsStatus.filter((obj: MultipleShoppingCartStatus) => obj.key === 'DELIVERED')[0].history.buckets
  const bucketsCancelled: MultipleShoppingCartHistory[] = bucketsStatus.filter((obj: MultipleShoppingCartStatus) => obj.key === 'CANCELLED')[0].history.buckets

  bucketsDelivered.map((bucket: MultipleShoppingCartHistory) => {
    categories.push(bucket.key_as_string)
    seriesDelivered.data.push(bucket.gmv.value)
  })

  bucketsCancelled.map((bucket: MultipleShoppingCartHistory) => {
    seriesCancelled.data.push(bucket.gmv.value)
  })

  const options = {
    chart: {
      id: 'sales-multiple-shopping-cart-delivered-cancelled-history'
    },
    xaxis: {
      categories,
      type: 'datetime',
      labels: {
        formatter: (value: Date) => {
          return moment(value).format('DD-MM-YYYY')
        }
      }
    },
    yaxis: {
      categories,
      logarithmic: false,
      labels: {
        formatter: (value: number) => {
          return formatCurrency(value)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>
      Pedidos cancelados x Pedidos entregues por dia (GMV)
    </Typography>
    <ChartColumnStacked options={options} series={[seriesCancelled, seriesDelivered]} theme={ChartLineThemes.twocolors} height={280} />
  </Paper>
}

export default MultipleShoppingCancelledDeliveredHistory
